<template>
  <suspense>
    <HomePage v-if="isLegacyHomepage" />
    <ContentfulRenderer v-else :component="Home" :content-type="'homepage'" :slug="slug" :activeOf="'Homepage'" />
  </suspense>
</template>

<script>
import HomePage from '@/pages/Home/HomePage.vue';

import ContentfulRenderer from './ContentfulRenderer.vue';
import Home from '@/components/contentful/ContentModels/Home.vue';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import Tracking from '@/components/commons/Tracking';
import useExperiment from '@/compositions/useExperiment';

export default {
  components: {
    ContentfulRenderer,
    HomePage,
  },
  setup() {
    const router = useRouter();
    // Will keep this around for at least one homepage cycle
    const isLegacyHomepage = computed(() => router.currentRoute.value.query?.hasOwnProperty('legacyhomepage'));

    const slug = computed(() => router.currentRoute.value.params?.slug);

    if (!isLegacyHomepage.value) {
      const { isFeatureVariant } = useExperiment();

      if (isFeatureVariant('interior-design-tile', 'on')) {
        Tracking.track('interior-design-tile-home-page', {
          on: true,
        });
      }
    }

    return {
      isLegacyHomepage,

      Home,
      slug,
    };
  },
};
</script>

<style lang="postcss"></style>
